import * as React from "react";

interface TooltipProps {
  children: React.ReactNode;
  content: React.ReactNode;
  show: boolean;
  position?: { x: number; y: number };
}

export const Tooltip: React.FC<TooltipProps> = ({
  children,
  content,
  show,
  position,
}) => {
  return (
    <div className="relative inline-block">
      {children}
      {show && position && (
        <div
          className="fixed z-50 pointer-events-none"
          style={{
            left: `${position.x}px`,
            top: `${position.y - 60}px`, // Position above the cursor
          }}
        >
          <div className="border-2 border-black bg-[#fbf1c7] shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] px-3 py-2">
            {content}
          </div>
        </div>
      )}
    </div>
  );
};

